import React from 'react';
import { CheckSquare } from 'lucide-react';
export function DeliverablesSection() {
  const items = ['Acceso al Dashboard de Detective.', '5 Casos en PDF Interactivos con Fichas de Evidencia.', 'Protocolo de Interrogatorio (Preguntas guiadas para hablar sin pelear).', 'Guía de Cierre para aterrizar los casos en su relación.'];
  return <section className="py-24 bg-noir-bg border-b border-noir-border relative" data-id="element-34">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-3xl" data-id="element-35">
        <div className="bg-noir-card border border-noir-border p-8 md:p-12 rounded-sm relative shadow-[0_0_30px_rgba(0,0,0,0.5)]" data-id="element-36">
          {/* Decorative corners */}
          <div className="absolute top-0 left-0 w-4 h-4 border-t-2 border-l-2 border-noir-muted" data-id="element-37"></div>
          <div className="absolute top-0 right-0 w-4 h-4 border-t-2 border-r-2 border-noir-muted" data-id="element-38"></div>
          <div className="absolute bottom-0 left-0 w-4 h-4 border-b-2 border-l-2 border-noir-muted" data-id="element-39"></div>
          <div className="absolute bottom-0 right-0 w-4 h-4 border-b-2 border-r-2 border-noir-muted" data-id="element-40"></div>

          <h2 className="text-2xl md:text-3xl font-mono font-bold text-noir-text mb-8 text-center uppercase tracking-widest border-b border-noir-border pb-6" data-id="element-41">
            ¿Qué Incluye Mi <span className="text-noir-alert" data-id="element-42">Descarga?</span>
          </h2>

          <ul className="space-y-6" data-id="element-43">
            {items.map((item, index) => <li key={index} className="flex items-start group" data-id="element-44">
                <div className="mt-1 mr-4 flex-shrink-0" data-id="element-45">
                  <CheckSquare className="w-6 h-6 text-noir-alert group-hover:scale-110 transition-transform" data-id="element-46" />
                </div>
                <span className="text-lg text-noir-text font-sans leading-relaxed" data-id="element-47">
                  {item}
                </span>
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}